export const OV = {
  navy: "#081226",
  navy2: "#0f2042",
  navy3: "#162b58",
  gold: "#E8752A",
  goldLight: "#FFD9B8",
  orange: "#D95D1E",
  surface: "#F4F6F9",
};

export const VISITING_FOR = [
  "Walking", "Gym / Fitness", "Swimming", "Sports", "Family Visit",
  "Café", "Enquiry", "Membership", "Event", "Other",
];

export const HEARD_FROM = [
  "Walk-in", "Friend / Family", "Instagram", "Facebook", "Google",
  "Hoarding", "Outdoor Advertising", "Influencer", "Referral", "Other",
];

export const INTERESTS = [
  "Gym", "Fitness Studio", "Swimming", "Badminton", "Tennis", "Pickleball",
  "Cricket", "Kids Activities", "Wellness", "Leisure", "Café", "Membership",
  "Family Membership", "Other",
];

export const GENDERS = ["Male", "Female", "Other"];

export const VISITOR_STATUSES = [
  "NEW VISITOR", "ENGAGED", "ENQUIRY", "INTERESTED", "HOT LEAD",
  "FOLLOW-UP", "TRIAL", "CONVERTED", "NOT INTERESTED", "CLOSED",
];

export const LEAD_STATUSES = [
  "New", "Contacted", "DNP", "Followup", "Visit Arranged", "Meeting Booked", "Visited",
  "Meeting Done", "Pipeline", "Sale done", "Closed", "Denied", "Disqualified",
];

export const SCHEDULE_STAGES = ["Visit Arranged", "Meeting Booked"];

export const DASHBOARD_STAGES = [
  { stage: "DNP", label: "DNP – Do Not Pickup" }, { stage: "Meeting Booked", label: "Meeting Booked" },
  { stage: "Meeting Done", label: "Meeting Done" }, { stage: "Pipeline", label: "Pipeline" },
  { stage: "Sale done", label: "Sale Done" }, { stage: "Followup", label: "Follow Up" }, { stage: "Contacted", label: "Contacted" },
];

export const TEAM_ROLES = ["Admin", "Manager", "Reception", "Sales Executive", "Marketing", "Security"];

export const QR_LOCATIONS = [
  "Main Gate", "Walking Gate", "Reception", "Parking", "Café", "Sports Area", "Marketing Event", "Hoarding", "Instagram", "Influencer",
];

export const MEMBERSHIP_TYPES = ["Blue Membership", "Gold Membership", "Other"];
export const TENURES = ["1 Month", "3 Months", "6 Months", "12 Months"];
export const BLUE_TENURES = ["15 Years", "25 Years"];
export const FAMILY_MEMBER_COUNTS = [1, 2, 3, 4, 5, 6];

export const STATUS_COLORS = {
  "NEW VISITOR": "bg-slate-100 text-slate-700",
  "ENGAGED": "bg-blue-100 text-blue-700",
  "ENQUIRY": "bg-indigo-100 text-indigo-700",
  "INTERESTED": "bg-violet-100 text-violet-700",
  "HOT LEAD": "bg-orange-100 text-orange-700",
  "FOLLOW-UP": "bg-amber-100 text-amber-700",
  "TRIAL": "bg-cyan-100 text-cyan-700",
  "CONVERTED": "bg-emerald-100 text-emerald-700",
  "NOT INTERESTED": "bg-rose-100 text-rose-700",
  "CLOSED": "bg-gray-200 text-gray-600",
  "New": "bg-slate-100 text-slate-700",
  "Contacted": "bg-blue-100 text-blue-700",
  "DNP": "bg-stone-200 text-stone-700",
  "Followup": "bg-amber-100 text-amber-700",
  "Visit Arranged": "bg-indigo-100 text-indigo-700",
  "Meeting Booked": "bg-violet-100 text-violet-700",
  "Visited": "bg-cyan-100 text-cyan-700",
  "Meeting Done": "bg-teal-100 text-teal-700",
  "Pipeline": "bg-orange-100 text-orange-700",
  "Sale done": "bg-emerald-100 text-emerald-700",
  "Closed": "bg-gray-200 text-gray-600",
  "Denied": "bg-rose-100 text-rose-700",
  "Disqualified": "bg-red-100 text-red-700",
};

export const RANGES = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "7days", label: "7 Days" },
  { value: "30days", label: "30 Days" },
  { value: "month", label: "This Month" },
];

export const CHART_COLORS = ["#E8752A", "#D95D1E", "#0f2042", "#0284C7", "#10B981", "#8B5CF6", "#EC4899", "#64748B", "#F59E0B", "#14B8A6"];

export function waLink(mobile, text) {
  let digits = (mobile || "").replace(/\D/g, "");
  if (digits.length === 10) digits = "91" + digits;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

export function waReminder(name, type, date, time) {
  const what = type === "Meeting Booked" ? "meeting" : "visit";
  return `Hi ${name}, this is a friendly reminder of your ${what} at Oneiros Varachha tomorrow, ${date} at ${time}.\n\nPlease reply to confirm, or let us know if you'd like to reschedule.\n\nWe look forward to seeing you!\n— Oneiros Varachha`;
}

export function waBriefing(member, date, items) {
  const lines = items.map((f, i) => `${i + 1}. ${f.time_label} – ${f.name} (${f.mobile}) · ${f.type}${f.notes ? `\n   ${f.notes.replace(`${f.type}: `, "")}` : ""}`).join("\n");
  return `Good morning ${member}!\n\nYour meetings & visits for today, ${date}:\n\n${lines}\n\nPlease call each client before they arrive.\n— Oneiros Varachha`;
}

export function stageAge(lead) {
  const hist = (lead.stage_history || []).filter((h) => h.stage === lead.status);
  const since = hist.length ? hist[hist.length - 1].at : lead.created_at;
  if (!since) return null;
  return Math.max(0, Math.floor((Date.now() - new Date(since).getTime()) / 86400000));
}

export function waNudge(name, stage, interest) {
  const topic = interest || "our facilities";
  const lines = {
    "DNP": `Hi ${name}, we tried calling you from Oneiros Varachha but couldn't connect. When would be a good time to talk about ${topic}?`,
    "Visited": `Hi ${name}, thank you for visiting Oneiros Varachha! How did you like it? We'd love to help you get started with ${topic}.`,
    "Meeting Done": `Hi ${name}, thank you for meeting our team at Oneiros Varachha. Do you have any questions about the ${topic} plans we discussed?`,
    "Pipeline": `Hi ${name}, just checking in from Oneiros Varachha. Shall we go ahead with your ${topic} membership? We're happy to help with anything you need.`,
  };
  return `${lines[stage] || `Hi ${name}, this is Oneiros Varachha. We'd love to help you with ${topic}. Would you like to visit us this week?`}\n\n— Oneiros Varachha`;
}

export function waMessage(name, interest) {
  return `Hi ${name}, thank you for visiting Oneiros Varachha.\n\nWe hope you had a great experience.\n\nYou showed interest in ${interest || "our facilities"}.\n\nOur team would be happy to share the membership and experience details with you.\n\n— Oneiros Varachha`;
}
